import React from 'react';
import { Typography } from '@mui/material';

import { LastSessionSection } from '../../AppointmentCard.styles';
import { formatSessionDate } from '../../AppointmentCard.utils';

interface LastSessionSummaryProps {
  lastSessionSummary?: string | null;
  lastSessionDate?: string | null;
}

/**
 * Last session summary section
 * Displays the date and summary of the patient's last session
 */
export const LastSessionSummary: React.FC<LastSessionSummaryProps> = ({
  lastSessionSummary,
  lastSessionDate,
}) => {
  const formattedDate = lastSessionDate ? formatSessionDate(lastSessionDate) : null;

  return (
    <LastSessionSection>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        Last Session Summary
        {formattedDate && (
          <>
            :{' '}
            <Typography component="span" variant="caption" color="text.secondary">
              {formattedDate}
            </Typography>
          </>
        )}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {lastSessionSummary || 'No previous session summary available.'}
      </Typography>
    </LastSessionSection>
  );
};